export default __webpack_public_path__ + "101ef3a9c87fcfaba4af8df35b1e1698.png";